export function formatScorePrecision(digits: number): string {
  return `1e-${Math.max(1, Math.min(12, Math.round(digits)))}`;
}

export function parseScorePrecision(value: string): number | undefined {
  const match = value.trim().toLowerCase().match(/^1e-(\d{1,2})$/);
  if (!match) return undefined;
  const digits = Number(match[1]);
  return Number.isInteger(digits) && digits >= 1 && digits <= 12
    ? digits
    : undefined;
}
